module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (267).677dd358.jpg";